<template>
  <div class="card bg-light d-flex flex-fill">
    <div class="card-header titulos-conteudo mb-2">{{camposConvite.f_summary}}</div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-12">
          <span>
            <small class="textoNegrito">{{mensagemEventoCancelado}}</small>
            <br/><br/>
            <small class="text-muted">Início: {{formatarDataHora(camposConvite.f_dtstart)}}</small>
            <br/>
            <small class="text-muted">Término: {{formatarDataHora(camposConvite.f_dtend)}}</small>
            <br/>
            <small class="text-muted">Local: {{camposConvite.f_location}}</small>
          </span>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="text-right">
        <b-button class="botoes" variant="outline-success btn-sm mr-1" @click="obterRetornoConviteCancelado(camposConvite)" :disabled="desabilitar">Ok</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/util/constants'
import util from '@/util'

export default {
  name: 'convitesCancelados',
  components: {},

  props: {
    camposConvite: [Object],
    desabilitar: Boolean
  },

  data: () => {
    return {
      mensagemEventoCancelado: 'Evento cancelado',
      flagsDeControle: {
        carregandoDados: {
          convites: {
            status: false
          }
        },
        manipulandoDados: {
          convites: {
            status: false
          }
        }
      }
    }
  },

  methods: {
    obterRetornoConviteCancelado (conviteCancelado) {
      const convite = {
        'f_id': conviteCancelado.f_id,
        'f_event': conviteCancelado.f_event,
        'f_status': constants.statusConvites.notificacaoLeituraCancelamento
      }
      let parametrosRequisicao = {
        convites: [convite]
      }
      this.$emit('retornoDoConvite', parametrosRequisicao)
    },

    formatarDataHora (data) {
      let dataFormatada = util.formatarData(data, 'DD/MM/YYYY HH:mm')
      return dataFormatada
    }
  }
}
</script>

<style scoped>
@import "./scss/inicio.scss";
</style>
